// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3dYWb","label":"styles_label__XUw5R"};